import { useCurrentDate } from "@kalyzee/kalyzee-ui";

export const useMainClock = (): Date => {
  return useCurrentDate(1000);
};